import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import Start from './pages/start'
import Chat from './pages/chat'
import React, { useEffect } from 'react'
import Axios from 'axios'
Axios.defaults.withCredentials = true

const AuthWrapper = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await Axios.get(process.env.REACT_APP_API_BASE_URL + '/api/auth/status', {
          withCredentials: true,
        })

        if (response.data.authenticated) {
          if (location.pathname === '/') {
            navigate('/chat')
          }
        } else {
          if (location.pathname !== '/') {
            navigate('/')
          }
        }
      } catch (error) {
        console.error('Auth check failed:', error)
        if (location.pathname !== '/') {
          navigate('/')
        }
      }
    }

    checkAuth()
  }, [location.pathname, navigate])

  return children
}

const App = () => (
  <AuthWrapper>
    <Routes>
      <Route path="/chat" element={<Chat />} />
      <Route path="/" element={<Start />} />
    </Routes>
  </AuthWrapper>
)

export default App
